module.exports = __webpack_public_path__ + "198415af413871454cfe70795bc4a168.png";